// extracted by mini-css-extract-plugin
export var divider = "_yi-0";